export default x => x instanceof Array ? x : [x]
